module.exports = __webpack_public_path__ + "static/img/icon_shield.c44e2308.png";